import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { DiscrepancyInfoWithTooltipModule } from 'src/app/audits/audit-details/discrepancy-info-with-tooltip/discrepancy-info-with-tooltip.module';
import { OrdersService } from 'src/app/inventory/components/receive-edi/orders.service';
import { FormattedDateModule } from '../../pipes/formatted-date/formatted-date.module';
import { FormattedDatePipe } from '../../pipes/formatted-date/formatted-date.pipe';
import { RecordDateModule } from '../../pipes/record-date/record-date.module';
import { RxNumberModule } from '../../pipes/rx-number/rx-number.module';
import { TransactionBadgeModule } from '../../pipes/transaction-badge/transaction-badge.module';
import { SideWidgetService } from '../../services/side-widget.service';
import { AmendDialogModule } from '../amend-dialog/amend-dialog.module';
import { BadgeModule } from '../badge/badge.module';
import { ButtonModule } from '../button/button.module';
import { DialogModule } from '../dialog/dialog.module';
import { EditTransactionDateModule } from '../edit-transaction-date/edit-transaction-date.module';
import { EnterPinDialogModule } from '../enter-pin-dialog/enter-pin-dialog.module';
import { ResetPinDialogModule } from '../reset-pin-dialog/reset-pin-dialog.module';
import { TooltipModule } from '../tooltip/tooltip.module';
import { TransactionDateChangeHistoryModule } from '../transaction-date-change-history/transaction-date-change-history.module';
import { RecordDetailsWidgetComponent } from './record-details-widget.component';

@NgModule({
  declarations: [
    RecordDetailsWidgetComponent,
  ],
  exports: [
    RecordDetailsWidgetComponent,
  ],
  imports: [
    CommonModule,
    RecordDateModule,
    BadgeModule,
    AmendDialogModule,
    ButtonModule,
    DialogModule,
    EnterPinDialogModule,
    ResetPinDialogModule,
    FormattedDateModule,
    TransactionBadgeModule,
    DiscrepancyInfoWithTooltipModule,
    EditTransactionDateModule,
    TooltipModule,
    TransactionDateChangeHistoryModule,
    RxNumberModule,
    TransactionBadgeModule
  ],
  providers: [
    FormattedDatePipe, OrdersService, SideWidgetService
  ],
})
export class RecordDetailsWidgetModule {
}
